<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
@if (contentfulArticlesOverviewListContent.length; as contentfulArticlesListContent) {
  <div class="related-articles-container container">
    <ul class="related-articles-list row">
      @for (contentfulArticleOverviewListContent of contentfulArticlesOverviewListContent | slice: 0 : 20; track $index) {
        <li class="related-articles-item-wrapper col-lg-3 col-md-4 col-sm-6 col-12">
          <div class="related-articles-item">
            <a class="related-articles-item-link" [href]="contentfulArticleOverviewListContent.slug">
              <div class="related-articles-item-image">
                <!-- 
                  Article images are displayed responsively with different sizes based on the screen width:
                  - For max-width: 575px, the image is rendered at 551px width and 367px height (1 column).
                  - For max-width: 767px, the image is rendered at 360px width and 240px height (2 columns).
                  - For 768px and above, the image is rendered at 306px width and 204px height (3 and 4 columns).

                  The srcset attribute provides images in different resolutions for standard and high-resolution screens:
                  - 551w, 1102w for max-width: 575px
                  - 360w, 720w for max-width: 767px
                  - 306w, 612w for 768px and above

                  Applying the webp format, quality percentage, the height and the width of the image will reduce the image size and improve the performance
                  More info: https://www.contentful.com/developers/docs/references/images-api/
                -->
                @if (contentfulArticleOverviewListContent.thumbnailImageUrl) {
                  <img
                    sizes="(max-width: 575px) 551px, (max-width: 767px) 360px, 306px"
                    [srcset]="
                      contentfulArticleOverviewListContent.thumbnailImageUrl +
                      '?fm=webp&q=75&fit=fill&w=551&h=367 551w,' +
                      contentfulArticleOverviewListContent.thumbnailImageUrl +
                      '?fm=webp&q=75&fit=fill&w=1102&h=734 1102w,' +
                      contentfulArticleOverviewListContent.thumbnailImageUrl +
                      '?fm=webp&q=75&fit=fill&w=360&h=240 360w,' +
                      contentfulArticleOverviewListContent.thumbnailImageUrl +
                      '?fm=webp&q=75&fit=fill&w=720&h=480 720w,' +
                      contentfulArticleOverviewListContent.thumbnailImageUrl +
                      '?fm=webp&q=75&fit=fill&w=306&h=204 306w,' +
                      contentfulArticleOverviewListContent.thumbnailImageUrl +
                      '?fm=webp&q=75&fit=fill&w=612&h=408 612w'
                    "
                    [src]="contentfulArticleOverviewListContent.thumbnailImageUrl + '?fm=webp&q=75&w=306&h=204'"
                    [alt]="contentfulArticleOverviewListContent.title + ' article link'"
                  />
                }
              </div>
              <div class="related-articles-item-text">
                <div class="related-articles-item-title">
                  {{ contentfulArticleOverviewListContent.title }}
                </div>
                <div class="related-articles-item-read-more">
                  <i class="fal fa-angle-right"></i>
                  <span i18n="@@product.moreInfo">More info</span>
                </div>
              </div>
            </a>
          </div>
        </li>
      }
    </ul>
  </div>
}
